import MY_CONFIG from "@/constants";

export const footerConfig = {
  logo: MY_CONFIG.ICON_URL,
  description:
    "Raashidh is your trusted companion for all things Islamic. We provide authentic, engaging, and accessible content to help you deepen your understanding of Islam and enrich your spiritual journey.",
  sections: [
    {
      title: "Quick Links",
      links: [
        { label: "Home", to: "/" },
        { label: "About Us", to: "/about" },
        { label: "Articles", to: "/articles" },
        { label: "Dua Collection", to: "/duas" }
      ]
    },
    {
      title: "Islamic Topics",
      links: [
        { label: "Quran", to: "/quran" },
        { label: "Hadith", to: "/hadith" },
        { label: "Seerah", to: "/seerah" },
        { label: "Kids Learning", to: "/kids" }
      ]
    },
    {
      title: "Support",
      links: [
        { label: "Contact", to: "/contact" },
        { label: "Donate", to: "/donate" },
        { label: "Legal Documents & Policies", to: "/legaldocuments" }
      ]
    }
  ],
  social: [
    // { icon: FaFacebook, to: "https://facebook.com" },
    // { icon: FaInstagram, to: "https://instagram.com" },
    // { icon: FaYoutube, to: "https://youtube.com" },
    // { icon: FaXTwitter, to: "https://x.com" }
  ],
  contact: {
    email: MY_CONFIG.EMAIL,
    phone: MY_CONFIG.PHONE,
    address: MY_CONFIG.MAILING_ADDRESS
  },
  copyright: MY_CONFIG.COPYRIGHT
};